// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/plugins/pace/pace-theme-minimal.min.css
// module id = 1596
// module chunks = 81